enum SIZES_TYPES {
  DEFAULT_FONT_SIZE = 'DEFAULT_FONT_SIZE',
  FORM_FONT_SIZE = 'FORM_FONT_SIZE',
  HEADER_HEIGHT = 'HEADER_HEIGHT',
  HEADER_BORDER_RADIUS = 'HEADER_BORDER_RADIUS',
  MAX_CONTAINER_WIDTH = 'MAX_CONTAINER_WIDTH',
  MIN_CONTACT_US_BUTTON_CONTAINER_HEIGHT = 'MIN_CONTACT_US_BUTTON_CONTAINER_HEIGHT',
  MAX_GO_BACK_CONTAINER_WIDTH = 'MAX_GO_BACK_CONTAINER_WIDTH',
  CONTAINER_MARGIN = 'CONTAINER_MARGIN',
  REDIRECT_BUTTON_MARGIN = 'REDIRECT_BUTTON_MARGIN',
  MIN_REDIRECT_BUTTON_WIDTH = 'MIN_REDIRECT_BUTTON_WIDTH',
  MAX_REDIRECT_BUTTON_WIDTH = 'MAX_REDIRECT_BUTTON_WIDTH',
  MOBILE_REDIRECT_BUTTON_HEIGHT = 'MOBILE_REDIRECT_BUTTON_HEIGHT',
  MIN_INPUT_WIDTH = 'MIN_INPUT_WIDTH',
  MAX_BUTTON_CONTAINER_WIDTH = 'MAX_BUTTON_CONTAINER_WIDTH',
  MAX_REDIRECTION_CONTAINER_WIDTH = 'MAX_REDIRECTION_CONTAINER_WIDTH',
  INPUT_HEIGHT = 'INPUT_HEIGHT'
}

export type SizeType = keyof typeof SIZES_TYPES;

const sizes: { [K in SizeType]: number } = {
  DEFAULT_FONT_SIZE: 16,
  FORM_FONT_SIZE: 14,
  HEADER_HEIGHT: 130,
  HEADER_BORDER_RADIUS: 65,
  MAX_CONTAINER_WIDTH: 1200,
  MIN_CONTACT_US_BUTTON_CONTAINER_HEIGHT: 190,
  MAX_GO_BACK_CONTAINER_WIDTH: 1460,
  CONTAINER_MARGIN: 54,
  REDIRECT_BUTTON_MARGIN: 8,
  MIN_REDIRECT_BUTTON_WIDTH: 212,
  MAX_REDIRECT_BUTTON_WIDTH: 250,
  MOBILE_REDIRECT_BUTTON_HEIGHT: 72,
  MIN_INPUT_WIDTH: 248, // 324
  MAX_BUTTON_CONTAINER_WIDTH: 800,
  MAX_REDIRECTION_CONTAINER_WIDTH: 500,
  INPUT_HEIGHT: 40
};

export default sizes;
